import { useState } from "react";
import api from "../api";
import { useTags } from "../components/ui";

const COLORS = ["#2563eb", "#16a34a", "#dc2626", "#d97706", "#7c3aed", "#0891b2", "#db2777", "#475569"];

export default function Tags() {
  const { tags, reload } = useTags();
  const [name, setName] = useState("");
  const [color, setColor] = useState(COLORS[0]);

  const create = async () => {
    if (!name.trim()) return;
    try {
      await api.post("/tags", { name: name.trim(), color });
      setName(""); reload();
    } catch (e) { alert("Errore: " + (e.response?.data?.detail || e.message)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare l'etichetta? Verrà rimossa dalle anagrafiche.")) return;
    await api.delete(`/tags/${id}`); reload();
  };

  return (
    <div>
      <h1 className="page-title">Etichette</h1>
      <p className="page-sub">Classifica le anagrafiche per tipologia e usale per filtrare e inviare comunicazioni</p>

      <div className="panel">
        <h3>Nuova etichetta</h3>
        <div className="toolbar">
          <input style={{ maxWidth: 240 }} placeholder="Nome etichetta (es. Forfettari)" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && create()} />
          <div className="tag-filter">
            {COLORS.map((c) => (
              <span key={c} onClick={() => setColor(c)} style={{ width: 26, height: 26, borderRadius: "50%", background: c, cursor: "pointer", border: color === c ? "3px solid #0f172a" : "3px solid transparent" }} />
            ))}
          </div>
          <button className="btn primary" onClick={create}>Aggiungi</button>
        </div>
      </div>

      <table>
        <thead><tr><th>Etichetta</th><th>Colore</th><th></th></tr></thead>
        <tbody>
          {tags.map((t) => (
            <tr key={t.id}>
              <td><span className="chip" style={{ background: t.color }}>{t.name}</span></td>
              <td><code className="muted">{t.color}</code></td>
              <td><button className="btn sm danger" onClick={() => remove(t.id)}>Elimina</button></td>
            </tr>
          ))}
          {tags.length === 0 && <tr><td colSpan={3}><div className="empty">Nessuna etichetta ancora.</div></td></tr>}
        </tbody>
      </table>
    </div>
  );
}
